import {
  AppBar,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Typography,
  InputAdornment,
  TextField,
} from "@mui/material";
import { styled } from "@mui/system";
import MenuIcon from "@mui/icons-material/Menu";
import React, { useState } from "react";
import config from "../config";
import SearchIcon from "@mui/icons-material/Search";
import LaunchIcon from '@mui/icons-material/Launch';

const StyledALink = styled("a")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  textDecoration: "none",
  ":visited": {
    textDecoration: "none",
    color: "#ffffff",
  },
});

const LogoIcon = styled("img")({
  height: "24px",
});

const Title = styled(Typography)({
  fontFamily: "Georgia",
  margin: "0px 12px",
});

const HeaderButton = styled(Button)({
  textTransform: "unset",
  color: "white",
  marginLeft: "1rem",
  boxShadow: "none",
  "@media (max-width: 650px)": {
    display: "none",
  }
});

const HeaderToolbar = styled(AppBar)({
  backgroundColor: "#1e1e1e",
  color: "#ffffff",
  borderBottom: "1px solid #333333",
  boxShadow: "none",
  position: "fixed",
});

const ButtonGroup = styled("div")({
  flexGrow: 1,
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
});

const StyledIconButton = styled(IconButton)({
  display: "none",
  "@media (max-width: 650px)": {
    display: "block",
  },
});

const DrawerContainer = styled(Drawer)({
  "& .MuiPaper-root": {
    backgroundColor: "#1e1e1e",
    color: "#ffffff",
  },
});

const links = [
  {
    name: "Go to Workflow86",
    href: config.LANDING_PAGE_ADDRESS + "?ref=templates_page",
    style: {
      backgroundColor: "#000",
    },
  },
];
/**
 *
 * @returns Main app bar
 */
const Header = () => {
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleSearch = (e) => {
    console.log(e.target.value);
  };

  return (
    <HeaderToolbar position="fixed">
      <Toolbar>
        <StyledALink href="/">
          <LogoIcon alt="Workflow86 logo icon" src="/images/Black logo white text.png" />
        </StyledALink>
        <ButtonGroup>
          {links.map(({ name, href, style }) => (
            <HeaderButton
              variant="contained"
              color="primary"
              key={name}
              target="_blank"
              href={href}
              style={style}
              startIcon={<LaunchIcon />}
            >
              {name}
            </HeaderButton>
          ))}
          <StyledIconButton onClick={() => setOpenDrawer(!openDrawer)}>
            <MenuIcon />
          </StyledIconButton>
        </ButtonGroup>
      </Toolbar>
      <DrawerContainer
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
        anchor="top"
      >
        <List>
          {links.map(({ name, href }) => (
            <ListItem
              button
              component="a"
              target="_blank"
              key={name}
              href={href}
            >
              <ListItemText primary={name} />
            </ListItem>
          ))}
        </List>
      </DrawerContainer>
    </HeaderToolbar>
  );
};

export default Header;
